import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false)
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''} ${isMenuOpen ? 'header--menu-open' : ''}`}>
      <div className="header__backdrop"></div>
      <div className="container header__container">
        <a href="/" className="header__logo">
          <span className="header__logo-text">RAYS</span>
          <span className="header__logo-accent">Rajagiri Association of Yesteryear Students</span>
        </a>

        <button 
          className={`header__menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`header__nav ${isMenuOpen ? 'active' : ''}`}>
          <div className="header__nav-items">
            <a 
              href="#about" 
              className="nav-item"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('about')
              }}
            >
              <span className="nav-item__icon">👥</span>
              <span className="nav-item__text">About</span>
            </a>
            <a 
              href="#features" 
              className="nav-item"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('features')
              }}
            >
              <span className="nav-item__icon">✨</span>
              <span className="nav-item__text">Features</span>
            </a>
            <a 
              href="#events" 
              className="nav-item"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('events')
              }}
            >
              <span className="nav-item__icon">📅</span>
              <span className="nav-item__text">Events</span>
            </a>
            <a 
              href="#contact" 
              className="nav-item"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('contact')
              }}
            >
              <span className="nav-item__icon">📞</span>
              <span className="nav-item__text">Contact</span>
            </a>
          </div>
          <button 
            className="header__cta"
            onClick={() => navigate('/register')}
          >
            Register Now
            <span className="header__cta-shine"></span>
          </button>
        </nav>
      </div>
    </header>
  )
}

export default Header 